import { isStringEmpty } from '@shared/utils';
import { useLayoutEffect, useMemo, useState, useEffect } from 'react';
import AntdTextarea from '../antd-hooks/antd-textarea';
import { SVGPureIcon } from '@/ui';
import wsStore from './store';
import globalStore from '@/store/global';
import chatStoreManager from '@/store/chat/manager';
import client, { SIZE_MODEL_SMALL } from '@/store/client';
import { observer } from 'mobx-react-lite';

function ChatInput(props) {
  const chatStore = wsStore.currentStore || {};
  const { className, onSend } = props;

  const isWeiShiMinWindow = client.isClient && client.sizeModel == SIZE_MODEL_SMALL;
  const store = isWeiShiMinWindow 
  ? wsStore.currentStore || chatStoreManager.current 
  : chatStoreManager.current;
  const { currAsstId } = store;

  console.log('currAsstId:',currAsstId);  

  const [autoSize, setAutoSize] = useState(false);
  const [value, setValue] = useState('');

  const disabled = useMemo(() => {
    return props.disabled || isStringEmpty(value);
  }, [props.disabled, value]);

  const isShowSo = useMemo(() => {
    return globalStore.getRobotOnlineSet(currAsstId);
  }, [currAsstId]);

  useEffect(() => {
    globalStore.robotOnlineSo(currAsstId);
  }, [currAsstId]);

  const handleSo = () => {
    globalStore.robotOnlineSo(currAsstId, !globalStore.is_so);
  }

  const handleSend = () => {
    if (disabled) {
      return;
    }

    chatStore.log({
      action : "click",
      arrt : "aibot_plugin_sidebar_sent",
    });
    chatStore.log({
      action : "act",
      arrt : "new_chat",
      ext : "text_input",
      ext1 : value,
    });

    onSend?.({ value });
    setValue('');
  };

  useLayoutEffect(() => {
    setAutoSize({ minRows: 2, maxRows: 6 });
  }, []);

  return (
    <div
      style={{ boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.05)' }}
      className={[
        'chat__input rounded-[16px]',
        'p-2px',
        'bg-white',
        className,
      ]}
    >
      <div className="p-10px bg-white rounded-14px">
        <AntdTextarea
          className={[
            'qihoo-ai-input-textarea !border-0 !p-0 !resize-none',
            '!bg-white',
            '!text-[15px] !leading-snug',
          ]}
          autoSize={autoSize}
          placeholder="输入你的问题"
          value={value}
          onInput={event => setValue(event.target.value)}
          onPressEnter={e => {
            if (e.shiftKey) {
              return;
            }
            e.preventDefault();
            handleSend();
          }}
        />

        <section className="flex justify-between items-center">
          <span>
          {
            isShowSo ? (<div
              className={['px-10px h-32px flex items-center rounded-full cursor-pointer', globalStore.is_so ? 'bg-[#dceaff]' : 'bg-normal hover:bg-hover-normal']}
              onClick={() => {
                handleSo();
              }}
            >
              <SVGPureIcon
                name="net"
                className={['size-20px mr-6px', globalStore.is_so ? 'text-[#2780FE]' : '']}
              />
              <span className={[globalStore.is_so ? 'text-[#2780FE]' : 'text-primary', 'text-14px font-bold']}>联网搜索</span>
            </div>) : null
          }
          </span>
          <button
            className={[
              'rounded-full p-[5px] send-btn',
              disabled ? 'send-btn-disable' : '',
            ]}
            onClick={() => {
              handleSend();
            }}
          >
            <SVGPureIcon name="plane" className={`size-22px text-white`} />
          </button>
        </section>
      </div>
    </div>
  );
}

export default observer(ChatInput);
